// Fee Commission Service - GraphQL operations for Admin role
import { graphqlClient } from '../graphqlClient';

// ==================== Fee Commission Queries ====================

export const listFeeCommissions = async (filters = {}) => {
  const query = `
    query ListFeeCommissions($filters: ListFeeCommissionFiltersInput) {
      listFeeCommissions(filters: $filters) {
        id
        entityType
        entityId
        depositFeeType
        depositFeeAmount
        withdrawalFeeType
        withdrawalFeeAmount
        depositCommissionType
        depositCommissionAmount
        withdrawalCommissionType
        withdrawalCommissionAmount
        minDepositFee
        maxDepositFee
        minWithdrawalFee
        maxWithdrawalFee
        minDepositCommission
        maxDepositCommission
        minWithdrawalCommission
        maxWithdrawalCommission
        description
        isActive
        createdAt
        updatedAt
      }
    }
  `;

  const result = await graphqlClient.query(query, { filters });
  return result.listFeeCommissions;
};

export const getFeeCommissionById = async (id) => {
  const query = `
    query GetFeeCommissionById($id: String!) {
      getFeeCommissionById(id: $id) {
        id
        entityType
        entityId
        depositFeeType
        depositFeeAmount
        withdrawalFeeType
        withdrawalFeeAmount
        depositCommissionType
        depositCommissionAmount
        withdrawalCommissionType
        withdrawalCommissionAmount
        minDepositFee
        maxDepositFee
        minWithdrawalFee
        maxWithdrawalFee
        minDepositCommission
        maxDepositCommission
        minWithdrawalCommission
        maxWithdrawalCommission
        description
        isActive
        createdAt
        updatedAt
      }
    }
  `;

  const result = await graphqlClient.query(query, { id });
  return result.getFeeCommissionById;
};

export const getFeeCommissionByEntity = async (entityType, entityId) => {
  const query = `
    query GetFeeCommissionByEntity($entityType: String!, $entityId: String) {
      getFeeCommissionByEntity(entityType: $entityType, entityId: $entityId) {
        id
        entityType
        entityId
        depositFeeType
        depositFeeAmount
        withdrawalFeeType
        withdrawalFeeAmount
        depositCommissionType
        depositCommissionAmount
        withdrawalCommissionType
        withdrawalCommissionAmount
        minDepositFee
        maxDepositFee
        minWithdrawalFee
        maxWithdrawalFee
        minDepositCommission
        maxDepositCommission
        minWithdrawalCommission
        maxWithdrawalCommission
        description
        isActive
        createdAt
        updatedAt
      }
    }
  `;

  const result = await graphqlClient.query(query, { entityType, entityId });
  return result.getFeeCommissionByEntity;
};

// ==================== Fee Commission Mutations ====================

export const createFeeCommission = async (input) => {
  const mutation = `
    mutation CreateFeeCommission($input: CreateFeeCommissionInput!) {
      createFeeCommission(input: $input) {
        id
        entityType
        entityId
        depositFeeType
        depositFeeAmount
        withdrawalFeeType
        withdrawalFeeAmount
        depositCommissionType
        depositCommissionAmount
        withdrawalCommissionType
        withdrawalCommissionAmount
        minDepositFee
        maxDepositFee
        minWithdrawalFee
        maxWithdrawalFee
        minDepositCommission
        maxDepositCommission
        minWithdrawalCommission
        maxWithdrawalCommission
        description
        isActive
        createdAt
        updatedAt
      }
    }
  `;

  const result = await graphqlClient.mutate(mutation, { input });
  return result.createFeeCommission;
};

export const updateFeeCommission = async (id, input) => {
  const mutation = `
    mutation UpdateFeeCommission($id: String!, $input: UpdateFeeCommissionInput!) {
      updateFeeCommission(id: $id, input: $input) {
        id
        entityType
        entityId
        depositFeeType
        depositFeeAmount
        withdrawalFeeType
        withdrawalFeeAmount
        depositCommissionType
        depositCommissionAmount
        withdrawalCommissionType
        withdrawalCommissionAmount
        minDepositFee
        maxDepositFee
        minWithdrawalFee
        maxWithdrawalFee
        minDepositCommission
        maxDepositCommission
        minWithdrawalCommission
        maxWithdrawalCommission
        description
        isActive
        createdAt
        updatedAt
      }
    }
  `;

  const result = await graphqlClient.mutate(mutation, { id, input });
  return result.updateFeeCommission;
};

export const deleteFeeCommission = async (id) => {
  const mutation = `
    mutation DeleteFeeCommission($id: String!) {
      deleteFeeCommission(id: $id)
    }
  `;

  const result = await graphqlClient.mutate(mutation, { id });
  return result.deleteFeeCommission;
};

// ==================== Fee Calculation ====================

export const calculateFeeBreakdown = async (input) => {
  const query = `
    query CalculateFeeBreakdown($input: FeeCalculationInput!) {
      calculateFeeBreakdown(input: $input) {
        adminFeeAmount
        engineFeeAmount
        resellerFeeAmount
        merchantFeeAmount
        totalFeeAmount
        netAmount
        details
      }
    }
  `;

  const result = await graphqlClient.query(query, { input });
  return result.calculateFeeBreakdown;
};
